import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Popover, OverlayTrigger, FormControl } from 'react-bootstrap';
import Select from 'react-select'
import cyberSecurityData from '../../../../../apis/cyberSecurityData';
import { updateBoard, setActiveBoard } from '../../../../../actions/Dashboard/boardsActions';

const AddChannel = ({ activeBoard }) => {
    //redux store state
    const accessToken = useSelector(state => state.accessToken);
    const boards = useSelector(state => state.dashboard_Boards.userBoards);
    //comp state
    const [channelName, setChannelName] = useState('');
    const [error, setError] = useState('');
    const dispatch = useDispatch();

    const onAddClick = async () => {
        if (!channelName) return setError('Please Add Channel Name')
        if (!channelName.match(/^[a-zA-Z0-9_ ]*$/)) return setError('Only characters and numbers')

        //checking if there is a channel with the same name
        if (activeBoard && activeBoard.channels && activeBoard.channels.includes(channelName)) return setError('There is a channel with the same name');

        // reset the error if there is an error after user has corrected the inputs
        if (error) setError('');

        //creating and SORTING the new channels array
        let newChannels = [];
        if (activeBoard && activeBoard.channels) newChannels = [...activeBoard.channels, channelName]
        newChannels.sort((a, b) => a.localeCompare(b))

        const response = await cyberSecurityData.post('/changeboardchannels', { boardId: activeBoard._id, newChannels }, {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }
        })

        const modifiedBoard = response.data;

        // dispatch(fetchUserBoards())
        dispatch(updateBoard(modifiedBoard))

        //reseting the fields and closing the adding popup
        setChannelName('');
        document.body.click()
    }

    const popover = (
        <Popover id="popover-basic">
            <Popover.Title as="h3" className="d-flex align-content-canter">
                <span>Add Channel</span>
                <span className="material-icons pointer text-light-grey text-sm ml-auto" onClick={() => document.body.click()}>close</span>
            </Popover.Title>
            <Popover.Content>
                <FormControl value={channelName} placeholder="Channel Name" onChange={(e) => setChannelName(e.target.value)} />
                {error && <p className="text-xs text-red mb-0">{error}</p>}
                <Button className="mt-3 mr-2" variant="primary" onClick={onAddClick}>Save</Button>
                <Button className="mt-3" variant="secondary" onClick={() => document.body.click()}>Delete</Button>
            </Popover.Content>
        </Popover>
    );

    return (
        <OverlayTrigger trigger="click" placement="right" overlay={popover} rootClose={true}>
            <span className="material-icons pointer text-light-grey">add</span>
        </OverlayTrigger>
    )
}

export default AddChannel
